exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_tabBarItem_31VIXtXkIOzTRt2alQB_zD {\n  width: 20%;\n  height: 50px;\n  position: relative;\n  float: left;\n  padding-top: 10px;\n  box-sizing: border-box;\n  user-select: none;\n  cursor: pointer;\n}\n\n.IA_title__6_1HysjxqE55LiZvKePH {\n  font-size: 11px;\n  text-align: center;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  max-width: 100%;\n  display: -webkit-box;\n  box-orient: vertical;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  user-select: none;\n}", ""]);

// Exports
exports.locals = {
	"IA_tabBarItem": "IA_tabBarItem_31VIXtXkIOzTRt2alQB_zD",
	"IA_title": "IA_title__6_1HysjxqE55LiZvKePH"
};